import React from 'react';
import { ApplicationType, Section } from './Intyg.enums';
import { AppContext, IAppContext, IFormStateBase } from './Intyg.types';
import _ from 'lodash';
import { FormSectionBase } from './FormSectionBase';
import ValjYrke from '../FormSections/ValjYrke';
import Personuppgifter from '../FormSections/Personuppgifter';
import TaEmotIntyget from '../FormSections/TaEmotIntyget';
import SprakForIntyget from '../FormSections/SprakForIntyget';
import Villkor from '../FormSections/Villkor';
import Adressuppgifter from '../FormSections/Adressuppgifter';

export class FormBase<TProps, TState extends IFormStateBase> extends React.Component<TProps, TState> {
  protected sectionRefMap: Map<Section, React.RefObject<FormSectionBase<any, any>>>;

  constructor(props: TProps) {
    super(props);

    this.sectionRefMap = new Map();
    this.sectionRefMap.set(Section.ValjYrke, React.createRef<ValjYrke>());
    this.sectionRefMap.set(Section.Personuppgifter, React.createRef<Personuppgifter>());
    this.sectionRefMap.set(Section.TaEmotIntyget, React.createRef<TaEmotIntyget>());
    this.sectionRefMap.set(Section.SprakForIntyget, React.createRef<SprakForIntyget>());
    this.sectionRefMap.set(Section.Adressuppgifter, React.createRef<Adressuppgifter>());
    this.sectionRefMap.set(Section.Villkor, React.createRef<Villkor>());
  }

  componentDidMount = () => {
    this.checkFormValidity();

    window.onbeforeunload = () => {
      if (this.context.applicationType === ApplicationType.Webform && this.context.isFormTouched) {
        return 'Är du säker på att du vill lämna sidan?';
      }
    };
  };

  componentDidUpdate = () => {
    this.checkFormValidity();
    };

    componentWillUnmount = () => {
        if (this.context.applicationType === ApplicationType.Webform) {
            window.onbeforeunload = null;
        }
    };

  isFormValid = (): boolean => {
    let isFormValid = true;

    for (const [key, value] of this.sectionRefMap.entries()) {
      if (value?.current?.hasErrors()) {
        isFormValid = false;
        break;
      }
    }
    return isFormValid;
  };

  checkFormValidity = () => {
    let isFormValid = this.isFormValid();

    if (this.state.isFormValid === isFormValid) return;

    this.setState({ isFormValid });
  };
}
